import { render, staticRenderFns } from "./Encabezado.vue?vue&type=template&id=dbdbabdc&scoped=true"
import script from "./Encabezado.vue?vue&type=script&lang=js"
export * from "./Encabezado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdbabdc",
  null
  
)

export default component.exports